import React from "react";

/**
 * ToggleSwitch — issue #750 § 5.15. A 44×26 navy pill switch, used for the
 * wicketkeeper tick on the scorecard (#711, #726 — the field itself is the
 * #704 data slice; this component only carries `checked`/`onChange`).
 */
export function ToggleSwitch({
  checked = false,
  onChange,
  disabled = false,
  className = "",
  tapBox = false,
  "data-testid": testId,
  ...rest
}) {
  // #1290 (D237): opt-in. The pill stays 44×26 and is drawn inside a
  // transparent 52×44 button, so the tap lands on 44px. Off by default: the
  // scorecard's wicketkeeper switch keeps its shape.
  if (tapBox) {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        data-testid={testId}
        onClick={() => onChange?.(!checked)}
        className={className}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 52,
          height: 44,
          border: "none",
          background: "transparent",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
          padding: 0,
        }}
        {...rest}
      >
        <span
          aria-hidden="true"
          style={{
            position: "relative",
            display: "block",
            width: 44,
            height: 26,
            borderRadius: "var(--nw-radius-pill)",
            background: checked ? "var(--nw-navy)" : "var(--nw-line-strong)",
            transition: "background 0.15s ease",
          }}
        >
          <span
            style={{
              position: "absolute",
              top: 3,
              left: checked ? 21 : 3,
              width: 20,
              height: 20,
              borderRadius: "var(--nw-radius-pill)",
              background: "#FFFFFF",
              transition: "left 0.15s ease",
            }}
          />
        </span>
      </button>
    );
  }
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      data-testid={testId}
      onClick={() => onChange?.(!checked)}
      className={className}
      style={{
        width: 44,
        height: 26,
        borderRadius: "var(--nw-radius-pill)",
        border: "none",
        background: checked ? "var(--nw-navy)" : "var(--nw-line-strong)",
        position: "relative",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        padding: 0,
        transition: "background 0.15s ease",
      }}
      {...rest}
    >
      <span
        aria-hidden="true"
        style={{
          position: "absolute",
          top: 3,
          left: checked ? 21 : 3,
          width: 20,
          height: 20,
          borderRadius: "var(--nw-radius-pill)",
          background: "#FFFFFF",
          transition: "left 0.15s ease",
        }}
      />
    </button>
  );
}

export default ToggleSwitch;
